import { render, staticRenderFns } from "./BarStats.vue?vue&type=template&id=563559de"
import script from "./BarStats.vue?vue&type=script&lang=js"
export * from "./BarStats.vue?vue&type=script&lang=js"
import style0 from "./BarStats.vue?vue&type=style&index=0&id=563559de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports